import { apiGet } from "./client";
import type { CarrierReadModel } from "../types/api";

// GET /api/v1/targets/{targetId}/carrier — see docs/API_CONTRACT.md.
export function getCarrierReadModel(targetId: string, signal?: AbortSignal) {
  return apiGet<CarrierReadModel>(
    `/api/v1/targets/${encodeURIComponent(targetId)}/carrier`,
    signal,
  );
}
